// import { getOrientation } from 'get-orientation/browser';
import { isString } from 'lodash';
import React, { memo, useEffect, useState } from 'react';
import Cropper, { Area } from 'react-easy-crop';

import Button from '../Button';

import { getCroppedImg } from './CanvasUtils';

const readFile = (file: Blob) => {
  return new Promise<string | ArrayBuffer | null>((resolve) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => resolve(reader.result), false);
    reader.readAsDataURL(file);
  });
};

export const ImageCropModal: React.FC<{
  target: HTMLInputElement;
  onSubmit: (imageSrc: Blob | null) => void;
}> = memo(({ target, onSubmit }) => {
  const [imageSrc, setImageSrc] = useState<string>('');
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  // const [rotation, setRotation] = useState(0);
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<Area>({
    width: 0,
    height: 0,
    x: 0,
    y: 0,
  });

  const onCropComplete = (croppedArea: Area, croppedAreaPixels: Area) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  const showCroppedImage = async () => {
    try {
      const croppedImage: Blob | null = await getCroppedImg(
        imageSrc,
        croppedAreaPixels
        // rotation
      );
      croppedImage && onSubmit(croppedImage);
    } catch (e) {
      console.error(e);
    }
  };

  const onFileChange = async (target: HTMLInputElement | undefined) => {
    if (target?.files && target.files.length > 0) {
      const file = target.files[0];
      const imageDataUrl: string | ArrayBuffer | null = await readFile(file);

      setImageSrc(String(imageDataUrl));
    }
  };

  useEffect(() => {
    onFileChange(target);
  }, [target]);

  return (
    <div className="text-center">
      <div className="relative w-full h-80 mt-10">
        <Cropper
          crop={crop}
          cropSize={{ height: 150, width: 1050 }}
          image={isString(imageSrc) ? imageSrc : ''}
          objectFit="horizontal-cover"
          // rotation={rotation}
          showGrid={false}
          zoom={zoom}
          onCropChange={setCrop}
          onCropComplete={onCropComplete}
          // onRotationChange={setRotation}
          onZoomChange={setZoom}
        />
      </div>
      <div className="flex justify-center space-x-2 mx-auto max-w-[320px] mt-10 ">
        <Button
          className="flex-1"
          type="button"
          variant="secondary"
          onClick={() => onSubmit(null)}
        >
          Cancelar
        </Button>
        <Button
          className="flex-1"
          type="button"
          variant="primary"
          onClick={showCroppedImage}
        >
          Cargar imagen
        </Button>
      </div>
    </div>
  );
});

ImageCropModal.displayName = 'ImageCropModal';
